export const generateKey = () => {
  const randNum = String(Math.random() * 10000)
  return String(Date.now() + parseInt(randNum))
}
export const stringToObj = (arr: string[] = []) => {
  const resArr: Array<ObjItem> = []
  if (!arr?.length) {
    return [
      {
        edit: true,
        key: generateKey(),
        value: ''
      }
    ]
  }
  arr.forEach((item: string) => {
    return resArr.push({
      edit: false,
      key: generateKey(),
      value: item
    })
  })
  return resArr
}
interface ObjItem {
  edit: boolean
  value: string
  key: string
}
export const ObjToString = (arr: Array<ObjItem> = []) => {
  const resArr: string[] = []
  arr.forEach((item: ObjItem) => {
    item.value = item.value.trim()
    if (item.value && resArr.indexOf(item.value) === -1) {
      resArr.push(item.value)
    }
  })
  return resArr
}
